const initNavigation = () => {
  const scrollTarget = document.querySelector('.kadenzec-homepage__featured')

  document.querySelectorAll('.graphic-tablet').forEach(el => {
    el.addEventListener('click', () => Kadenze.UIUtil.scrollTo(scrollTarget, 0.7))
  })
}

const watchElementForAnimation = (element, animation) => {
  window.addEventListener('scroll', () => {
    if (Kadenze.UIUtil.isInFullView(element))
      return animation()
  })
}

const membershipAnimation = _.once(() => {
  if (document.querySelectorAll('.feature__graphic-membership').length) {
    const svg = Snap()
    const group = Snap('#svg-membership-icon')
    const character = group.select('#svg-membership-icon-character')
    const computer = group.select('#svg-membership-icon-computer')
    const square1Fill = computer.select('#square-1-fill')
    const square2 = computer.select('#square-2')
    const square3 = computer.select('#square-3')

    svg.attr({ 'viewBox': '0 0 165 243' });
    svg.append(group.node);
    document.querySelector('.membership-svg').appendChild(svg.node);

    //
    // Callback HELL, where's the promises snap!?
    // TODO: Re factor anonymous functions to named functions at least
    //
    character.animate({ opacity: 1}, 400, mina.easeout, () => {
      computer.animate({ opacity: 1 }, 200, mina.easeout, () => {
        square1Fill.animate({ opacity: 1 }, 200, mina.easeout, () => {
          square2.animate({ opacity: 1 }, 200, mina.easeout, () => {
            square3.animate({ opacity: 1 }, 200, mina.linear);
          });
        });
      });
    });
  }
});

const creditAnimation = _.once(() => {
  if (document.querySelectorAll('.feature__graphic-college').length) {
    const svg = Snap()
    const group = Snap('#svg-credit-icon')
    const building = group.select('#svg-credit-icon-building')
    const medal = group.select('#svg-credit-icon-medal')

    svg.attr({ 'viewBox': '0 0 250 193' });
    svg.append(group.node);
    document.querySelector('.credit-svg').appendChild(svg.node);

    medal.attr({ transform: 'translate(0 20)', opacity: 0 });
    building.attr({ transform: 'translate(0, 20)', opacity: 0 });

    setTimeout(() => {
      medal.animate(
        {
          transform: 'translate(0, 2)',
          opacity: 1
        },
        400,
        mina.backout,
        () => {
          building.animate(
            {
              transform: 'translate(0, 2)',
              opacity: 1
            },
            400,
            mina.backout
          );
        }
      );
    }, 1000);
  }
});

const classroomAnimation = _.once(() => {
  if(document.querySelectorAll('.feature__graphic-classroom').length) {
    const svg = Snap()
    const group = Snap('#svg-schedule-icon')
    const computer = group.select('#svg-schedule-computer')
    const people = group.select('#svg-schedule-people')

    const matrix = new Snap.Matrix();

    svg.attr({ 'viewBox': '0 0 252 212' });
    svg.append(group.node);
    document.querySelector('.classroom-svg').appendChild(svg.node);

    matrix.scale(1);
    matrix.translate(0,0);

    computer.attr({ transform: 'translate(0, 20)', opacity: 0 });

    setTimeout(() => {
      computer.animate(
        {
          transform: 'translate(0, 2)',
          opacity: 1
        },
        400,
        mina.backout,
        () => people.animate({ opacity: 1 }, 200, mina.backout)
      );
    }, 1800);
  }
});

const initializeCoupon = () => {
  const couponInput = document.getElementById('js-membership-coupon-id');

  if (couponInput)
    setTimeout(() => {
      document.querySelector('.js-slide-hero[data-move-to="0"]')
        .dispatchEvent(new Event('click'))
    }, 1000);
};

export default {
  init() {
    if (document.querySelectorAll('.kadenzec-homepage').length) {
      initNavigation();

      watchElementForAnimation('.feature__graphic-membership', membershipAnimation);
      watchElementForAnimation('.feature__graphic-college', creditAnimation);
      watchElementForAnimation('.feature__graphic-classroom', classroomAnimation);

      //
      // pause carousel on focus
      //
      $('body')
        .off('focus.slickFocusPause')
        .on('focus.slickFocusPause', '.slick-list', () => $('.ticker').slick('slickPause'))

      $('body')
        .off('blur.slickFocusPause')
        .on('blur.slickFocusPause', '.slick-list', () => $('.ticker').slick('slickPlay'))

      const $carousel = $('.carousel.js-carousel');

      $carousel.on('init', () => {
        const $slickPrevArrow = $('.carousel__controls-prev');

        $slickPrevArrow.detach();
        $carousel.prepend($slickPrevArrow);
        setCardLinkTabIndexes();
      });

      $carousel.on('afterChange', () => {
        setCardLinkTabIndexes();

        $('.slick-slide.slick-current')
          .find('.course-card__actions > a.js-course-action-button')
          .focus();
      });

      const setCardLinkTabIndexes = () => {
        //
        // improve tabability for accessiblity/wcag
        //
        $carousel
          .find('.slick-slide')
          .find('a, btn')
          .attr('tabindex', '-1');

        $carousel
          .find('.slick-slide.slick-active')
          .find('.kd-card__footer_secondary > a')
          .attr('tabindex', '');

        $carousel
          .find('.slick-slide.slick-active')
          .find('.kd-card__entry-thumb_link')
          .attr('tabindex', '');
      };

      const setTickerTabIndexes = () => {
        $('.slick-slide').attr('tabindex', '-1');
        $('.slick-slide.slick-active').attr('tabindex', '');
      };

      const $ticker = $('.ticker');

      $ticker.on('init', setTickerTabIndexes);

      $ticker.on('afterChange', setTickerTabIndexes);

      document.querySelector('.kadenzec-homepage__quote')
        .classList
        .add('with-image');

      initializeCoupon();
    }
  }
};
